import { SWRConfiguration } from "swr";

// Fetcher for GET requests
export const fetcher = async (url: string) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

// Fetcher for POST requests
export const poster = async (url: string, { arg }: { arg: unknown }) => {
  const response = await fetch(url, {
    body: JSON.stringify(arg),
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// Fetcher for PUT requests
export const putter = async (url: string, { arg }: { arg: unknown }) => {
  const response = await fetch(url, {
    body: JSON.stringify(arg),
    headers: {
      "Content-Type": "application/json",
    },
    method: "PUT",
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// Fetcher for DELETE requests
export const deleter = async (url: string) => {
  const response = await fetch(url, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// Default SWR configuration
export const swrConfig: SWRConfiguration = {
  dedupingInterval: 2000,
  errorRetryCount: 3,
  errorRetryInterval: 5000,
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
};
